const CUSTOMER_REVIEW_STATUS_ENUM = {
  VISIBLE: 'VISIBLE',
  REJECTED: 'REJECTED',
  PENDING: 'PENDING'
};
export default { CUSTOMER_REVIEW_STATUS_ENUM };
